<template>
    <AppLayout>
        <div class="bg-white">
            <div class="pt-6">
                <nav aria-label="Breadcrumb">
                    <ol role="list"
                        class="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                        <li v-for="breadcrumb in page.breadcrumbs" :key="breadcrumb.id">
                            <div class="flex items-center">
                                <a :href="breadcrumb.href" class="mr-2 text-sm font-medium text-gray-900">{{
                                    breadcrumb.name
                                    }}</a>
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor" aria-hidden="true"
                                    class="h-5 w-4 text-gray-300">
                                    <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                                </svg>
                            </div>
                        </li>
                        <li class="text-sm">
                            <a href="#" aria-current="page" class="font-medium text-gray-500 hover:text-gray-600">{{
                                page.name }}</a>
                        </li>
                    </ol>
                </nav>

                <!-- page info -->
                <div
                    class="mx-auto max-w-2xl px-4 pt-10 pb-16 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-1 lg:grid-rows-[auto_auto_1fr] lg:gap-x-8 lg:px-8 lg:pt-16 lg:pb-24">
                    <div class="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
                        <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{{ page.name }}</h1>
                    </div>

                    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div class="lg:col-span-2 max-md:order-1">
                            <p class="text-gray-500 text-sm mt-4">Complete your payment process to get the course.</p>

                            <div class="mt-6">
                                <div>
                                    <div class="grid gap-4 lg:grid-cols-2 mt-6">
                                        <div
                                            class="max-w-sm rounded-xl border border-gray-200 bg-white p-4">
                                            <div>
                                                <div class="flex items-center">
                                                    <input type="radio" name="plan" class="w-5 h-5 cursor-pointer"
                                                        :id="`book-${book.id}`"
                                                        :checked="true"
                                                        :value="book.id"
                                                    />
                                                    <label :for="`plan-${book.id}`" class="ml-4 flex gap-2 cursor-pointer">
                                                        <span class="text-gray-900 font-semibold">{{ book.title }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-8 max-w-lg">
                                <h3 class="text-lg font-semibold text-gray-900">Choose your payment method</h3>
                                <div class="flex flex-wrap gap-4 justify-between mt-6">
                                    <div class="flex items-center">
                                        <input type="radio" class="w-5 h-5 cursor-pointer" id="paypal" checked />
                                        <label for="paypal" class="ml-4 flex gap-2 cursor-pointer">
                                            <img src="https://readymadeui.com/images/paypal.webp" class="w-20"
                                                alt="paypalCard" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div v-if="book" class="rounded-2xl border border-gray-200 bg-white p-6 shadow-soft">
                                <h2 class="text-2xl font-bold text-gray-900">{{ book.price }}</h2>
                                <ul class="text-gray-500 font-medium mt-8 space-y-4">
                                    <li class="flex flex-wrap gap-4 text-sm">{{ book.title }}
                                        <span class="ml-auto font-semibold text-gray-900">{{ book.price }}</span>
                                    </li>
                                    <li
                                        class="flex flex-wrap gap-4 text-[15px] font-semibold text-gray-900 border-t border-gray-200 pt-4">
                                        Total <span class="ml-auto">{{ book.price }}</span></li>
                                </ul>
                                <Button label="Pay now" class="mt-6 w-full" @click="handlePayment"
                                    :disabled="!book || loading" />
                                <p class="text-sm text-gray-500 mt-4">By clicking "Pay now", you agree to our terms and
                                    conditions.</p>
                            </div>
                            <div v-else class="rounded-2xl border border-gray-200 bg-white p-6 shadow-soft">
                                <p class="text-gray-500 font-medium">Please select a plan to proceed with the payment.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import { h, ref } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'primevue/button';
import { getBookById } from '@/services/bookService';
import { handleBookPayment } from '@/services/paymentService';

const route = useRoute();
const book = ref(null);
const loading = ref(false);

if (route.params.id) {
    getBookById(route.params.id).then(data => {
        book.value = data.data;
    });
}

const page = {
    name: 'Make a payment',
    breadcrumbs: [
        { id: 1, name: 'Home', href: '/' },
    ],
};

const handlePayment = () => {
    loading.value = true;
    handleBookPayment({
        book: book.value.id,
    }).then(response => {
        // redirect to PayPal or handle the response accordingly
        if (response.approval_url) {
            loading.value = false;
            window.location.href = response.approval_url;
        } else {
            alert('Payment initiation failed. Please try again.');
        }
    });
};

</script>